/**
 * Support account emails configured via environment (must match API SUPPORT_*_EMAIL values).
 * Used only for UI flows that skip customer email-existence checks.
 */
export function getSupportAccountEmails() {
  const adminEmail = (process.env.REACT_APP_SUPPORT_ADMIN_EMAIL || '').trim().toLowerCase();
  const envEmail = (process.env.REACT_APP_SUPPORT_ENV_EMAIL || '').trim().toLowerCase();
  return [adminEmail, envEmail].filter(Boolean);
}

export function isSupportAccountEmail(email) {
  const normalized = String(email || '').trim().toLowerCase();
  if (!normalized) return false;
  return getSupportAccountEmails().includes(normalized);
}
